import useGetUserNewsTips from './useGetUserNewsTips'

export default useGetUserNewsTips
